export const SEARCH_SPLIT_REGEX = /[\s+/]/g;

export const DROPDOWN_SEARCH_DEFAULT_MAX_LENGTH = 200;

// Sentinel value assigned to the pinned "Clear selection" Select.Item so it
// participates in Radix's roving focus / typeahead. Intercepted in
// DropdownSingleSelect's onValueChange before reaching the consumer.
export const DROPDOWN_CLEAR_SENTINEL_VALUE = '__chords_dropdown_clear__';
